module.exports = __webpack_public_path__ + "img/upi.d4ccec6e.svg";